enum ScreenId {
  HOME = "/",
  BANNER = "/banner",
  BANNER_EVENT_IMG = "/banner/eventimage",
  BANNER_HOTEL_IMG = "/banner/eventhotelimage",
  BANNER_EVENT_REFERRAL = "/banner/eventReferral",
  BANNER_EVENT_CASHBACK = "/banner/eventcashback",
  COMPANY = "/company",
  COMPANY_DETAIL = "/company/detail",
  COMPANY_DETAIL_SPOTLIST = "/company/detail/Spotlist",
  COMPANY_DETAIL_CLOTHES = "/company/detail/SelectClothes",
  COMPANY_DETAIL_ENTRY = "/company/detail/insertEntryInfoPage",
  COMPANY_DETAIL_REVIEW = "/company/detail/review",
  COMPANY_REVIEW_WRITE = "/company/detail/review/reviewwrite",
  SIGN_ON = "/SignOn",
  SIGN_IN = "/SignIn",
  MY_PROFILE = "/SignIn/MyProfilePage",
  MY_POINTLIST = "/SignIn/MyPointList",
  MY_POINTAPPLY = "/SignIn/MyPointList/PointApplyPage",
  MY_INQUIRY_LIST = "/SignIn/InquiryBoxList",
  MY_INQUIRY_DETAIL = "/SignIn/InquiryBoxList/detail",
  EVENT_RESERVATION = "/event/reservation",
  RECOMMEND_WEDDING_HALL = "/recommend",
  WEDDING_HALL = "/wedding/hall",
  WEDDING_DATE = "/wedding/date",
  COUNSELING_DATE = "/counseling/date",
  COUNSELING_INFO = "/counseling/info",
  KAKAO_LOGIN = "/kakaoLogin",
  PDF_PAGE = "/PDFPage",
  PROMOTION = "/promotion",
  PROMOTION_B2B = "/b2b_promotion",
  PROMOTION_KAKAO = "/kakao_promotion",
}

export default ScreenId;
